import BaseComponent from "../BaseComponent";
import DirectionInput from "components/Properties/InputComponents/DirectionInput";
import DirectionDropDownInput from "components/Properties/InputComponents/DirectionDropDownInput";
import MultipleDropDownInput from "components/Properties/InputComponents/MultipleDropDownInput";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import { useCallback, useState } from "react";

const TransformComponent = ({selectedObject, transformOnChange, dropdownOnChange, dropdownOpened, setDropdownOpened, checkboxOnChange}) => {
  const {position, rotation, scale} = selectedObject;
  const guiTransform = selectedObject.userData.guiTransform;
  const [isInputMode, setIsInputMode] = useState(false)
  const onFocus= useCallback(() =>{
    setIsInputMode(true)
  })
  const onBlur = useCallback(() => {
    setIsInputMode(false)
  })
  // transform value that displayed on UI (can even express '-'(minus sign alone), not only numbers)
  const positionDisplayed = {};
  if (selectedObject.userData.temporalInput?.position.x !== undefined && isInputMode)
    positionDisplayed.x = selectedObject.userData.temporalInput.position.x;
  else {
    positionDisplayed.x = position.x;
    if (selectedObject.userData.temporalInput)selectedObject.userData.temporalInput.position.x = position.x
  }
  if (selectedObject.userData.temporalInput?.position.y !== undefined && isInputMode)
    positionDisplayed.y = selectedObject.userData.temporalInput.position.y;
  else {
    positionDisplayed.y = position.y
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.position.y = position.y
  }
  if (selectedObject.userData.temporalInput?.position.z !== undefined && isInputMode)
    positionDisplayed.z = selectedObject.userData.temporalInput.position.z;
  else {
    positionDisplayed.z = position.z
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.position.z = position.z
  }

  const rotationDisplayed = {};
  if (selectedObject.userData.temporalInput?.rotation.x !== undefined && isInputMode)
    rotationDisplayed.x = selectedObject.userData.temporalInput.rotation.x;
  else {
    rotationDisplayed.x = rotation.x;
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.rotation.x = rotation.x;
  }
  if (selectedObject.userData.temporalInput?.rotation.y !== undefined && isInputMode)
    rotationDisplayed.y = selectedObject.userData.temporalInput.rotation.y;
  else {
    rotationDisplayed.y = rotation.y;
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.rotation.y = rotation.y;
  }
  if (selectedObject.userData.temporalInput?.rotation.z !== undefined && isInputMode)
    rotationDisplayed.z = selectedObject.userData.temporalInput.rotation.z;
  else {
    rotationDisplayed.z = rotation.z;
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.rotation.z = rotation.z;
  }

  const scaleDisplayed = {};
  if (selectedObject.userData.temporalInput?.scale.x !== undefined && isInputMode) 
    scaleDisplayed.x = selectedObject.userData.temporalInput.scale.x;
  else {
    scaleDisplayed.x = scale.x;
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.scale.x = scale.x;
  }
  if (selectedObject.userData.temporalInput?.scale.y !== undefined && isInputMode) 
    scaleDisplayed.y = selectedObject.userData.temporalInput.scale.y;
  else {
    scaleDisplayed.y = scale.y;
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.scale.y = scale.y;
  }
  if (selectedObject.userData.temporalInput?.scale.z !== undefined && isInputMode) 
    scaleDisplayed.z = selectedObject.userData.temporalInput.scale.z;
  else {
    scaleDisplayed.z = scale.z;
    if (selectedObject.userData.temporalInput) selectedObject.userData.temporalInput.scale.z = scale.z;
  }

  return (
    <BaseComponent title="Transform" foldable={true}>
      {selectedObject.type === "Sprite" && (
        <>
          <DirectionInput
            name="Center"
            value={selectedObject.center}
            transformOnChange={transformOnChange}
            is2D={selectedObject.isSprite}
          />
          <MultipleDropDownInput
            name="Anchor"
            arrays={{
              X: ["Far-Left", "Center", "Far-Right"],
              Y: ["Bottom", "Center", "Top"],
            }}
            dropdownOnChange={dropdownOnChange}
            values={{
              X: guiTransform.anchor.x,
              Y: guiTransform.anchor.y,
            }}
            selectedObject={selectedObject}
            dropdownOpened={dropdownOpened}
            setDropdownOpened={setDropdownOpened}
          />
          <DirectionDropDownInput
            name="Offset"
            values={{
              X: {
                name: "SpriteOffset-x",
                value: guiTransform.offset.x.value,
                array: ["px", "%"],
                selected: guiTransform.offset.x.unit,
              },
              Y: {
                name: "SpriteOffset-y",
                value: guiTransform.offset.y.value,
                array: ["px", "%"],
                selected: guiTransform.offset.y.unit,
              },
            }}
            selectedObject={selectedObject}
            transformOnChange={transformOnChange}
            dropdownOnChange={dropdownOnChange}
            dropdownOpened={dropdownOpened}
            setDropdownOpened={setDropdownOpened}
          />
          <DirectionDropDownInput
            name="Size"
            values={{
              X: {
                name: "SpriteSize-x",
                value: guiTransform.size.x.value,
                array: ["px", "%"],
                selected: guiTransform.size.x.unit,
              },
              Y: {
                name: "SpriteSize-y",
                value: guiTransform.size.y.value,
                array: ["px", "%"],
                selected: guiTransform.size.y.unit,
              },
            }}
            selectedObject={selectedObject}
            transformOnChange={transformOnChange}
            dropdownOnChange={dropdownOnChange}
            dropdownOpened={dropdownOpened}
            setDropdownOpened={setDropdownOpened}
          />
          <ToggleInput name="Maintain AspectRatio" checked={guiTransform.constantAspectRatio} checkboxOnChange={checkboxOnChange} />
        </>
      )}
      {selectedObject.type !== "Sprite" && (
        <>
          <DirectionInput name="Position" value={positionDisplayed} transformOnChange={transformOnChange} is2D={selectedObject.isSprite} onFocus={onFocus} onBlur={onBlur}/>
          <DirectionInput name="Rotation" value={rotationDisplayed} transformOnChange={transformOnChange} is2D={selectedObject.isSprite} onFocus={onFocus} onBlur={onBlur}/>
          {selectedObject.userData.type !== "audio" && (
            <DirectionInput name="Scale" value={scaleDisplayed} transformOnChange={transformOnChange} is2D={selectedObject.isSprite} onFocus={onFocus} onBlur={onBlur}/>
          )}
        </>
      )}
    </BaseComponent>
  );
};

export default TransformComponent;
